export default __webpack_public_path__ + "static/media/ic_unidex.251545a0.png";